import PropTypes from 'prop-types';
import React from "react";
import * as rmd from 'material-ui';
import auth from '../auth';
import config from 'cfg';
import { Link } from 'react-router';
import uc from '../styles/images/under_construction.png'
import tw from '../styles/images/tw.png'
import fb from '../styles/images/fb.png'
import st from '../styles/images/st.png'
import et from '../styles/images/edit_theme.png'
import cw from '../styles/images/create_widget.png'
import suggested from '../styles/images/suggested.png'
import getGoogleApiClient from 'google-client-api';
import ContentAdd from 'material-ui/svg-icons/content/add';

class WidgetsStats extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            widgets: [],
            isLoading: true
        };

        this.loadData();
    }

    loadData = () => {

        var {user} = this.context;

        if (!user || !user.client) return null;

        return fetch(`${config.dash.api.host}/api/widgets/names?client=${user.client}`)
            .then(response => response.json())
            .then(body => this.setState({widgets: body.widgets, isLoading: false}))
            .catch(err => {
                console.error(err);
                this.setState({error: err, isLoading: false});
            });
    }

    componentDidMount() {
        var user = this.context.user;

        getGoogleApiClient().then((gapi) => {
            gapi.load('analytics', () => {
                return fetch(`${config.dash.api.host}/api/auth/google/token`)
                    .then(response => response.json())
                    .then(tokens => {
                        gapi.analytics.auth.authorize({
                            'serverAuth': {
                                'access_token': tokens.access_token
                            }
                        });
                        this.state.widgets.forEach((widget, i) => {
                            setTimeout(this.buildCharts.bind(this, "/" + widget + "/", `view-selector-${widget}`, `timeline-${widget}`), i * 300);                           ;
                        });
                    });
            });
        });
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    }

    render () {
        var user = this.context.user;

        return (
            <div className="home">
                <rmd.Subheader>
                    <div>Hi, {user.username}</div>
                </rmd.Subheader>
                <div className="row">
                    <rmd.Subheader>
                        <div>Stats per widget:</div>
                    </rmd.Subheader>
                    {this.state.widgets.map(widget => {
                        return (
                            <div className="col-md-12" style={{display: 'block'}} >
                                <rmd.Card className="home-info-card">
                                    <rmd.CardTitle
                                        title={`${widget}`}
                                    />

                                    <div id={`view-selector-${widget}`} style={{display: 'none'}}></div>
                                    <div id={`timeline-${widget}`}></div>
                                </rmd.Card>
                            </div>
                        );
                    })}

                </div>
            </div>
        )
    }

    buildCharts = (path, viewSelectorContainer, chartContainer) => {

        var viewSelector = new gapi.analytics.ViewSelector({
            container: viewSelectorContainer
        });
        viewSelector.execute();

        var dataChart = new gapi.analytics.googleCharts.DataChart({
            query: {
                metrics: 'ga:sessions, ga:pageviews, ga:users',
                dimensions: 'ga:date',
                filters: `ga:pagePath=@${path}`,
                'start-date': '30daysAgo',
                'end-date': 'yesterday'
            },
            chart: {
                container: chartContainer,
                type: 'LINE',
                options: {
                    width: '100%'
                }
            }
        });
        viewSelector.on('change', function(ids) {
            var newIds = {
                query: {
                    ids: ids
                }
            }
            dataChart.set(newIds).execute();
        });
    }
}

export default WidgetsStats;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetsSummary.js
 **/